import { createApi } from '@reduxjs/toolkit/query/react';

import { authQuery } from './baseQuery';

export const analyticsAPISlice = createApi({
  reducerPath: 'presentation-service-analytics-api',
  tagTypes: ['Analytics'],
  baseQuery: authQuery,
  endpoints: (builder) => ({
    getDashboardUrl: builder.query<
      {
        url: string;
        expiresAt: string;
      },
      string
    >({
      query: () => `/analytics`,
      providesTags: ['Analytics'],
      // the dashboard URL is consumed once viewed, so caching is purely a detriment here
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetDashboardUrlQuery } = analyticsAPISlice;
